import axios from "axios";
import ThemeMaker from "../../components/thememaker";
import { config } from "../../utils/config";
import { useState, useEffect } from "react";
import { toast } from "react-toastify";
import { Link } from "react-router-dom";
import { useParams } from "react-router-dom";
import Papa from 'papaparse';
import CloseIcon from '@mui/icons-material/Close';
import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';
import * as XLSX from 'xlsx';
import brandStyles from '../Brand/Brand.module.css';
import styles from './Addroducttype.module.css';
import "../../components/mcrbTableTheme.css";


const Sstyle = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  borderRadius: "16px",
  bgcolor: 'background.paper',
  boxShadow: 'none',
  outline: 'none',
  p: 0,
};
export default function Addroducttype() {
  const { apiEndpoint } = config;
  const PRODUCT_TYPE_NAME_MAX_LENGTH = 100;
  const ONDC_MAPPING_MAX_LENGTH = 150;

  function validateProductTypeName(value: string): string {
    const name = value.trim();
    if (!name) return "Product Type Name is required.";
    if (name.length > PRODUCT_TYPE_NAME_MAX_LENGTH) return `Name cannot exceed ${PRODUCT_TYPE_NAME_MAX_LENGTH} characters.`;
    if (!/^[\p{L}\p{N}][\p{L}\p{N}\s&,'()./-]*$/u.test(name)) {
      return "Use letters, numbers, spaces, and common punctuation (& , ' ( ) . / -).";
    }
    return "";
  }

  function validateOndcMapping(value: string): string {
    const mapping = value.trim();
    if (!mapping) return "";
    if (mapping.length > ONDC_MAPPING_MAX_LENGTH) return `ONDC Mapping cannot exceed ${ONDC_MAPPING_MAX_LENGTH} characters.`;
    if (!/^@ondc\/org\/[a-z0-9_]+$/.test(mapping)) {
      return "Mapping must use the format @ondc/org/mapping_name.";
    }
    return "";
  }
  const [isSubmitting, setisSubmitting] = useState(false);
  const params: any = useParams()
  const [ptData, setptData] = useState({
    name: "",
    ondc_mapping: "",
    status: true
  })
  const [validationErrors, setValidationErrors] = useState({ name: "", ondc_mapping: "" });

  useEffect(() => {
    if (params?.id) {
      getProductTypeById()
    }
  }, [])



  const catMapping: any = {
    'Fruits and Vegetables': "",
    'Masala & Seasoning': '@ondc/org/statutory_reqs_packaged_commodities',
    'Oil & Ghee': '@ondc/org/statutory_reqs_packaged_commodities',
    'Eggs, Meat & Fish': '@ondc/org/statutory_reqs_packaged_commodities',
    'Cleaning & Household': '@ondc/org/statutory_reqs_packaged_commodities',
    'Bakery, Cakes & Dairy': '@ondc/org/statutory_reqs_prepackaged_food',
    'Pet Care': '@ondc/org/statutory_reqs_packaged_commodities',
    'Stationery': '@ondc/org/statutory_reqs_packaged_commodities',
    'Dairy and Cheese': '@ondc/org/statutory_reqs_prepackaged_food',
    'Snacks, Dry Fruits, Nuts': '@ondc/org/statutory_reqs_prepackaged_food',
    'Pasta, Soup and Noodles': '@ondc/org/statutory_reqs_packaged_commodities',
    'Cereals and Breakfast': '@ondc/org/statutory_reqs_prepackaged_food',
    'Sauces, Spreads and Dips': '@ondc/org/statutory_reqs_prepackaged_food',
    'Chocolates and Biscuits': '@ondc/org/statutory_reqs_prepackaged_food',
    'Cooking and Baking Needs': '@ondc/org/statutory_reqs_packaged_commodities',
    'Tinned and Processed Food': '@ondc/org/statutory_reqs_prepackaged_food',
    'Atta, Flours and Sooji': '@ondc/org/statutory_reqs_packaged_commodities',
    'Rice and Rice Products': '@ondc/org/statutory_reqs_packaged_commodities',
    'Dals and Pulses': '@ondc/org/statutory_reqs_packaged_commodities',
    'Salt, Sugar and Jaggery': '@ondc/org/statutory_reqs_packaged_commodities',
    'Energy and Soft Drinks': '@ondc/org/statutory_reqs_prepackaged_food',
    'Water': "",
    'Tea and Coffee': '@ondc/org/statutory_reqs_packaged_commodities',
    'Fruit Juices and Fruit Drinks': '@ondc/org/statutory_reqs_prepackaged_food',
    'Snacks and Namkeen': '@ondc/org/statutory_reqs_prepackaged_food',
    'Ready to Cook and Eat': '@ondc/org/statutory_reqs_prepackaged_food',
    'Pickles and Chutney': '@ondc/org/statutory_reqs_prepackaged_food',
    'Indian Sweets': '@ondc/org/statutory_reqs_prepackaged_food',
    'Frozen Vegetables': "",
    'Frozen Snacks': '@ondc/org/statutory_reqs_prepackaged_food',
    'Gift Voucher': "",
    'Fragrance': '',
    'Bath Soaps and Gels': '',
    'Hair Oils, Care, and Styling': '',
    'Shampoos and Conditioners': '',
    'Shaving and Grooming': '',
    'Beard Care and Tools': '',
    'Grooming Tools and Accessories': '',
    'Makeup - Nail Care': '',
    'Makeup - Eyes': '',
    'Makeup - Face': '',
    'Makeup - Lips': '',
    'Makeup - Body': '',
    'Makeup - Remover': '',
    'Makeup - Sets and Kits': '',
    'Makeup - Tools and Brushes': '',
    'Makeup - Kits and Combos': '',
    'Skin Care - Face Cleansers': '',
    'Skin Care - Hand and Feet': '',
    'Body Care - Cleansers': '',
    'Body Care - Moisturizers': '',
    'Body Care - Loofah and Other Tools': '',
    'Body Care - Bath Salt and Additives': '',
    'Hair Care - Shampoo, Oils, Conditioners': '',
    'Skin Care - Lotions, Moisturisers, and Creams': '',
    'Skin Care - Oils and Serums': '',
    'Mobile Phone': '',
    'Smart Watch': '',
    'Headset': '',
    'Laptop': '',
    'Desktop': '',
    'Tablet': '',
    'Keyboard': '',
    'Monitor': '',
    'Mouse': '',
    'Power Bank': '',
    'Earphone': '',
    'True Wireless Stereo (TWS)': '',
    'Adapter': '',
    'Cable': '',
    'Extension Cord': '',
    'Audio Accessories': '',
    'Home Audio': '',
    'Microphone': '',
    'Speaker': '',
    'Vehicle Audio': '',
    'Camcorder': '',
    'Camera': '',
    'Camera Bag': '',
    'Batteries': '',
    'Charger': '',
    'Camera Lens': '',
    'Photo Printer': '',
    'Tripod': '',
    'Camera Accessories': '',
    'UPS': '',
    'Networking Device': '',
    'Printer': '',
    'Printer Accessories': '',
    'Storage Drive': '',
    'Pen Drive': '',
    'Memory Card': '',
    'Computer Component': '',
    'Cooling Pad': '',
    'Docking Station': '',
    'Keyboard Guard': '',
    'Laptop Skin': '',
    'Laptop Stand': '',
    'Mousepad': '',
    'Laptop Bag': '',
    'Screen Protector': '',
    'Computer Accessories': '',
    'Computer Software': '',
    'Ebook Reader': '',
    'Tablet Accessories': '',
    'Gaming Controller': '',
    'Gaming Chair': '',
    'Gaming Accessories': '',
    'Gaming Console': '',
    'Video Games': '',
    'Mobile Cover': '',
    'Mobile Mount': '',
    'Mobile Screen Guard': '',
    'Selfie Stick': '',
    'Mobile Skin Sticker': '',
    'Biometrics': '',
    'Home Alarm': '',
    'Home Automation': '',
    'Smart Switch': '',
    'Smart Lighting': '',
    'Home Safe': '',
    'Intercom': '',
    'Sensor': '',
    'Smart TV': '',
    'Standard TV': '',
    'TV Mount': '',
    'Remote': '',
    'Streaming Device': '',
    'TV Accessories': '',
    'Virtual Reality Headset': '',
    '3D Glasses': '',
    '3D Modulator': '',
    'Projector': '',
    'Projector Screen': '',
    'Projector Mount': '',
    'Projector Accessories': '',
    'TV Part': '',
    'TV Remote': '',
    'Set Top Box': '',
    'TV Stand': '',
    'Video Player': '',
    'Digital Photo Frame': '',
    'Home Theatre Projector': '',
    'Video Player Accessories': '',
    'Smart Band': '',
    'Smart Glasses': '',
    'Watch Strap Band': '',
    'Wearable Accessories': '',

    'Air Purifier': '',
    'Dehumidifier': '',
    'Humidifier': '',
    'Air Cleaner Accessories': '',
    'Air Conditioner': '',
    'Air Conditioner Accessories': '',
    'Air Cooler': '',
    'Trimmer': '',
    'Shaver': '',
    'Epilator': '',
    'Hair Straightener': '',
    'Hair Dryer': '',
    'Hair Curler': '',
    'Hair Crimper': '',
    'Electric Brush': '',
    'Electric Iron': '',
    'Electric Sewing Machine': '',
    'Water Heater': '',
    'Heater Cables': '',
    'Air Heater': '',
    'Coffee Maker': '',
    'Beverage Maker': '',
    'Roti Maker': '',
    'Induction Cooktop': '',
    'Sandwich Maker': '',
    'Electric Cooker': '',
    'Electric Kettle': '',
    'Microwave Oven': '',
    'OTG': '',
    'Toaster': '',
    'Electric Air Fryer': '',
    'Cooking Appliance Accessories': '',
    'Coffee Grinder': '',
    'Food Processor': '',
    'Pasta Maker': '',
    'Food Processor Accessories': '',
    'Blender': '',
    'Juicer': '',
    'Mixer Grinder': '',
    'Wet Grinder': '',
    'Dishwasher': '',
    'Dishwasher Accessories': '',
    'Electric Chimney': '',
    'Kitchen Accessories': '',
    'Freezer': '',
    'Refrigerator': '',
    'Refrigerator Accessories': '',
    'Vacuum Cleaner': '',
    'Vacuum Cleaner Parts and Accessories': '',
    'Washing Machine': '',
    'Washing Machine Accessories': '',
    'Water Purifier': '',
    'Water Cooler': '',
    'Water Dispenser': '',
    'Water Purifier Service Kit': '',
    'Water Purifier Filter': '',
    'Water Purifier Candle': '',
    'Water Purifier Pipe': '',
    'Water Purifier Accessories': '',
    'Water Cooler Accessories': '',
    'Inverter': '',
    'Inverter Batteries': '',
    'Battery Tray': '',
    'Voltage Stabilizer': ''

  }

  function changeHandler(e: any) {
    if (e.target.name !== "status") {
      const { name, value } = e.target;
      setptData((prev) => {
        return { ...prev, [name]: value }
      })
      setValidationErrors((prev) => ({
        ...prev,
        [name]: name === "name" ? validateProductTypeName(value) : validateOndcMapping(value),
      }));
    } else {
      setptData((prev) => {
        return { ...prev, [e.target.name]: e.target.checked }
      })
    }
  }

  async function submitHandler() {
    const name = ptData.name.trim();
    const ondc_mapping = ptData.ondc_mapping.trim();
    const nextErrors = {
      name: validateProductTypeName(name),
      ondc_mapping: validateOndcMapping(ondc_mapping),
    };
    setValidationErrors(nextErrors);
    if (nextErrors.name || nextErrors.ondc_mapping) {
      toast.error(nextErrors.name || nextErrors.ondc_mapping);
      return
    }

    try {
      setisSubmitting(true)
      const { data } = await axios({
        url: `${apiEndpoint}/addprotype`,
        method: "POST",
        headers: {
          "x-custom-authorization": `Bearer ${sessionStorage.getItem('us_st_d')}`,
        },
        data: {
          ...ptData,
          name,
          ondc_mapping,
        }
      })

      if (data.status === 200) {
        toast.success("Product Type Added");
        setisSubmitting(false);
        setptData({
          name: "",
          ondc_mapping: "",
          status: true
        })
      } else {
        toast.error("Error In Adding Product Type");
        setisSubmitting(false)
      }
    } catch (err) {
      toast.error("Error in API")
      setisSubmitting(false)
    }


  }


  async function updateHandler() {
    const name = ptData.name.trim();
    const ondc_mapping = ptData.ondc_mapping.trim();
    const nextErrors = {
      name: validateProductTypeName(name),
      ondc_mapping: validateOndcMapping(ondc_mapping),
    };
    setValidationErrors(nextErrors);
    if (nextErrors.name || nextErrors.ondc_mapping) {
      toast.error(nextErrors.name || nextErrors.ondc_mapping);
      return
    }

    try {
      setisSubmitting(true)
      const { data } = await axios({
        url: `${apiEndpoint}/updateprotype`,
        method: "POST",
        headers: {
          "x-custom-authorization": `Bearer ${sessionStorage.getItem('us_st_d')}`,
        },
        data: {
          ...ptData,
          name,
          ondc_mapping,
          id: params.id
        }
      })

      if (data.status === 200) {
        toast.success("Product Type Updated");
        setisSubmitting(false);

      } else {
        toast.error("Error In Updating Product Type");
        setisSubmitting(false)
      }
    } catch (err) {
      setisSubmitting(false)
      toast.error("Error in API")
    }


  }

  async function getProductTypeById() {
    try {

      const { data } = await axios({
        url: `${apiEndpoint}/getprotype`,
        method: "POST",
        headers: {
          "x-custom-authorization": `Bearer ${sessionStorage.getItem('us_st_d')}`,
        },
        data: {
          id: params.id
        }

      })
      console.log(data)
      if (data.status === 200) {
        setptData({
          name: data.data[0].name,
          ondc_mapping: data.data[0].ondc_mapping,
          status: data.data[0].status,
        })
      } else {
        toast.error("Error In Loading ");

      }
    } catch (err) {

      toast.error("Error in API")
    }
  }
  const [shipmentModalOpen, setshipmentModalOpen] = useState(false);
  const [mandatoryAttrModalOpen, setmandatoryAttrModalOpen] = useState(false);
  const [file, setFile] = useState<any>(null);
  const handleImport = async () => {
    // console.log(file)
    Papa.parse(file, {
      header: true,
      dynamicTyping: true,
      complete: ({ data }) => {
        console.log(data)
        let abc = data.filter((item: any) => item.name !== null)
        let orders = abc.map((order: any) => ({
          name: order.name ?? "",
          ondc_mapping: order.ondc_mapping ?? "",
          product_category_name: order.product_category_name ?? ""
        }))
        let jsonData = {
          product_types: orders
        };
        console.log("jsonData", jsonData)
        sendDataToDb(jsonData)
      },
    });
  };
  const [mafile, setmaFile] = useState(null);
  const handleMAFileChange = (event: any) => {
    const selectedFile = event.target.files[0];
    console.log(selectedFile)
    if (selectedFile && selectedFile.type === "text/csv") {
      setmaFile(selectedFile);
    } else {
      alert("Please select a valid CSV file.");
    }
  };
  const handleMAImport = async () => {
    const formData: any = new FormData();
    formData.append("file", mafile);
    console.log(formData);
    // return 
    let result = await axios({
      url: `${apiEndpoint}/import_mandate_attribute`,
      method: 'POST',
      headers: {
        "x-custom-authorization": `Bearer ${sessionStorage.getItem('us_st_d')}`,
        "Content-Type": "multipart/form-data"
      },
      data: formData


    })
    toast.success("Imported Successfully!");
    setmandatoryAttrModalOpen(false)
    console.log(result)
  };

  async function sendDataToDb(jsonData: any) {
    try {
      // console.log(jsonData)
      let result = await axios({
        url: `${apiEndpoint}/addProductTypeCsv`,
        method: 'POST',
        headers: {
          "x-custom-authorization": `Bearer ${sessionStorage.getItem('us_st_d')}`,
        },
        data: jsonData,

      })

      if (result.status === 200) {
        // console.log("success")
        toast.success("Product Types added successfully !");
        setFile(null)
        let inputelement: any = document.getElementById('inputFile');
        inputelement.value = ''
      } else {
        // console.log("this is from succes if")
        toast.error("403 error !");
      }
    } catch (error) {
      toast.error("403 error !");
    }
  }

  function handleShipementModalClose() {
    setshipmentModalOpen(false)
  }
  function handleMAModalClose() {
    setmandatoryAttrModalOpen(false)
  }

  async function getSampleCsv() {
    try {
      const { data } = await axios({
        url: `${apiEndpoint}/download_product_type_csv`,
        method: "GET",
        headers: {
          "x-custom-authorization": `Bearer ${sessionStorage.getItem('us_st_d')}`
        }
      })
      if (data && (data.status === 200 || data.status === "200" || Number(data.status) === 200)) {
        const headers = Object.keys(data?.data[0]);
        const wb = XLSX.utils.book_new();
        const ws = XLSX.utils.json_to_sheet(data?.data, { header: headers });
        XLSX.utils.book_append_sheet(wb, ws, 'Orders');
        const fileName = `Sample_Product_Type_${new Date().getTime()}.csv`;
        XLSX.writeFile(wb, fileName);
      }
    } catch (err) {
      toast.error("Server not working, please try later!")
      console.log(err)
    }
  }

  return (
    <ThemeMaker>
      <div className={`${brandStyles.pageWrap} mcrb-page`}>
        <div className={`${brandStyles.cardOuter} mcrb-card`}>
          <div className={brandStyles.headerBar}>
            <span className={brandStyles.title}>Add Product Type</span>
            <div className={styles.headerActions}>

              <button className={styles.secondaryBtn} onClick={() => {
                setmandatoryAttrModalOpen(true)
              }}>Import Mandatory Attributes</button>

              <button className={styles.secondaryBtn} onClick={() => {
                setshipmentModalOpen(true)
              }}>Import</button>

              <Link to="/producttypelist" >
                <button className={brandStyles.primaryBtn}>Product Type List</button>
              </Link>
            </div>
          </div>

          <div className={brandStyles.bodyArea} style={{ minHeight: "70vh" }}>

            <div className="row">

              <div className="col-md-6">
                <div className={brandStyles.field}>
                  <label className={brandStyles.label}>
                    Name<span className={brandStyles.required}>*</span>
                  </label>
                  <input type="text" name="name" value={ptData.name} maxLength={PRODUCT_TYPE_NAME_MAX_LENGTH} className={brandStyles.input} placeholder="Enter Product Type Name" onChange={changeHandler} aria-invalid={Boolean(validationErrors.name)} />
                  {validationErrors.name && <span className={brandStyles.errorText}>{validationErrors.name}</span>}
                </div>

              </div>
              <div className="col-md-6">
                <div className={brandStyles.field}>
                  <label className={brandStyles.label}>
                    ONDC Mapping
                  </label>
                  <input type="text" className={brandStyles.input} name="ondc_mapping" placeholder="Enter ONDC Mapping" value={ptData.ondc_mapping} maxLength={ONDC_MAPPING_MAX_LENGTH} aria-invalid={Boolean(validationErrors.ondc_mapping)}
                    onChange={changeHandler}
                  />
                  {validationErrors.ondc_mapping && <span className={brandStyles.errorText}>{validationErrors.ondc_mapping}</span>}
                </div>

              </div>

              <div className="col-md-12">
                <div className={brandStyles.field}>
                  <label className={brandStyles.label}>Status</label>
                  <div className={brandStyles.statusRow}>
                    <input type="checkbox" name="status"
                      className={brandStyles.checkbox}
                      checked={ptData.status}
                      onChange={changeHandler}
                    />
                    <span style={{ fontSize: "13px", color: "#6B7280", fontWeight: 600 }}>
                      {ptData.status ? "Active" : "Inactive"}
                    </span>
                  </div>
                </div>
              </div>

              <div className="col-md-12 mt-1">

                {params.id === undefined ? <button className={brandStyles.saveBtn} onClick={submitHandler} >{isSubmitting ? "Please Wait" : "Submit"}</button> : <button className={brandStyles.updateBtn} onClick={updateHandler} >{isSubmitting ? "Please Wait" : "Update"}</button>}

              </div>
            </div>
          </div>
        </div>

        <>
          {/*  <Modal
            open={shipmentModalOpen}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Box sx={Sstyle} className="col-md-4 w-100 w-md-25">
              <div className="modal-content ">
                <div className="modal-header p-2 d-flex align-items-center justify-content-between">
                  <p className="modal-title genericlabel  " style={{ letterSpacing: "1px" }}>Import Using Excel File..</p>
                  <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                    <span style={{ cursor: "pointer" }} ><CloseIcon onClick={handleShipementModalClose} /></span>
                  </button>
                </div>
                <div className="modal-body">
                  <div className="importingSection">
                    <input type="file" id="inputFile" onChange={(e: any) => {
                      setFile(e.target.files[0]);
                    }} />


                  </div>
                </div>
                <div className="modal-footer">
                  <button className="btn btn-primary" onClick={handleImport} > Submit </button>
                </div>
              </div>
            </Box>
          </Modal>
*/}
          <Modal
            open={shipmentModalOpen}
            // onClose={handleShipementModalClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Box sx={Sstyle} className={`col-md-4 w-100 w-md-25 ${styles.modalBox}`}>

              <div className={styles.modalHeader}>
                <p className={styles.modalTitle}>Import Using Excel File..
                  <span className={styles.downloadLink} onClick={getSampleCsv}>Download Sample CSV</span></p>
                <span className={styles.modalClose}><CloseIcon onClick={handleShipementModalClose} /></span>
              </div>
              <div className={styles.modalBody}>
                <input type="file" id="inputFile" className={styles.modalFileInput} onChange={(e: any) => {
                  setFile(e.target.files[0]);
                }} />
              </div>
              <div className={styles.modalFooter}>
                <button className={styles.modalSubmitBtn} onClick={handleImport} > Submit </button>
              </div>
            </Box>
          </Modal>
          <Modal
            open={mandatoryAttrModalOpen}
            // onClose={handleShipementModalClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Box sx={Sstyle} className={`col-md-4 w-100 w-md-25 ${styles.modalBox}`}>

              <div className={styles.modalHeader}>
                <p className={styles.modalTitle}>Import Using CSV File..</p>
                <span className={styles.modalClose}><CloseIcon onClick={handleMAModalClose} /></span>
              </div>
              <div className={styles.modalBody}>
                <input type="file" id="inputFile" className={styles.modalFileInput} onChange={(e: any) => {
                  handleMAFileChange(e)
                }} />
              </div>
              <div className={styles.modalFooter}>
                <button className={styles.modalSubmitBtn} onClick={handleMAImport} > Submit </button>
              </div>
            </Box>
          </Modal>
        </>
      </div>

    </ThemeMaker>
  )
}
